import { createSlice } from '@reduxjs/toolkit';

const freeSpinSlice = createSlice({
  name: 'freeSpin',

  /**
   * @type {import('./IFreeSpinSlice').IState}
   */
  initialState: {
    providers: {},
    campaignByGroupId: {},
    gamesProvider: {},
    gameBets: {}
  },
  reducers: {
    setProviders: (state, action) => {
      const { groupId, providers } = action.payload;
      state.providers[groupId] = providers;
    },
    setCampaignByGroupId: (state, action) => {
      state.campaignByGroupId = action.payload;
    },
    setNewGamesProvider(state, action) {
      const { groupId, provider, games } = action.payload;
      if (!state.gamesProvider[groupId]) state.gamesProvider[groupId] = {};
      state.gamesProvider[groupId][provider] = games;
    },
    setNewGameBets(state, action) {
      const { groupId, gameId, bets } = action.payload;
      if (!state.gameBets[groupId]) state.gameBets[groupId] = {};
      state.gameBets[groupId][gameId] = bets;
    },
    addFSCampaign: (state, action) => {
      const { groupId, data } = action.payload;
      let newData = { ...state.campaignByGroupId };
      const campaignsGroup = newData?.[groupId];
      if (campaignsGroup) {
        // проверка по ИД
        const newCampaignsGroup = campaignsGroup.filter((el) => el.campaignId !== data.campaignId);
        console.log('newCampaignsGroup', newCampaignsGroup);
        console.log('data', data);

        newData = { ...newData, [groupId]: [...newCampaignsGroup, data] };
      } else {
        newData = { ...newData, [groupId]: [data] };
      }

      state.campaignByGroupId = newData;
    },
    deleteFSCampaign(state, action) {
      const { groupId, campaignId } = action.payload;
      const newData = JSON.parse(JSON.stringify(state.campaignByGroupId));

      const newCampaignList = newData[groupId].filter((el) => el.campaignId !== campaignId);
      newData[groupId] = newCampaignList;
      console.log(newData);
      state.campaignByGroupId = newData;
    }
  }
});

export default freeSpinSlice.reducer;

export const {
  setCampaignByGroupId,
  addFSCampaign,
  deleteFSCampaign,
  setProviders,
  setNewGameBets,
  setNewGamesProvider
} = freeSpinSlice.actions;
